<template>
  <main-body></main-body>
</template>
<script>
const main = () => import("@/view/main");
export default {
  name: "app",
  components: {
    mainBody: main
  },
  mounted() {
  }
};
</script>

<style lang="less" >
@import "~@/assets/styles/reset.less";
@import "~@/assets/styles/icon.less";
.el-loading-spinner .circular{
  width: 200px;
  height: 200px;
  // animation: loading-rotate 1s linear infinite;
  display: none;
}
.el-loading-spinner{
  background: url(./assets/加载GIF.gif) no-repeat;
  background-size: 200px 200px;
  width: 100%;
  height: 100%;
  position: relative;
  top: 30% !important;
  left: 45%;
}
.el-loading-spinner .el-loading-text {
    color: #409EFF;
    margin: 126px 81px !important;
    font-size: 14px;
    text-align: left;
}
</style>
